import React from 'react';

import { PrintCustomsRequestLog as PrintCustomsRequestLogInner } from '@components/utilities/CustomsRequest/PrintCustomsRequestLog';

export const PrintCustomsRequestLog = () => {
  return <PrintCustomsRequestLogInner type="admin" />;
};
